import React, { useState } from 'react';
import Popper, { PopperPlacementType } from '@material-ui/core/Popper';
import { Fade, Paper, ClickAwayListener, Button, MenuList, MenuItem } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { PersonRole } from '../../models/eums/personRole';
import { personHasRole } from '../../utils/personUtils';

interface Props {
  title: string;
  options: { itemName: string; route: string; userRoles?: PersonRole[] }[];
  popperPosition: PopperPlacementType;
}
export default function NavDropdown(props: Props) {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState<PopperPlacementType>();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (newPlacement: PopperPlacementType) => (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorEl(event.currentTarget);
    setOpen(prev => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  function handleClose() {
    setOpen(false);
  }

  function handleMenuItemAccess(roles?: PersonRole[]) {
    let authorized = false;
    roles
      ? roles.forEach(role => {
          if (personHasRole(role)) {
            authorized = true;
          }
        })
      : (authorized = true);

    return authorized;
  }

  return (
    <div>
      <Popper open={open} anchorEl={anchorEl} placement={placement} transition disablePortal>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={150}>
            <Paper elevation={2}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open}>
                  {props.options.map((option, index) =>
                    handleMenuItemAccess(option.userRoles) ? (
                      <MenuItem
                        type='button'
                        onClick={handleClose}
                        component={Link}
                        to={option.route}
                        key={index}
                      >
                        {option.itemName}
                      </MenuItem>
                    ) : null,
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
      <Button onClick={handleClick(props.popperPosition)}>{props.title}</Button>
    </div>
  );
}
